var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-header", attrs: { role: "banner" } },
    [
      _c(
        "b-modal",
        {
          ref: "modalTermsOfUse",
          attrs: {
            id: "modalTermsOfUse",
            size: "xl",
            "header-class": "terms-of-use-modal-header",
            "aria-label": _vm.$t("termosdeuso"),
            "no-close-on-esc": true,
            "no-close-on-backdrop": true,
            "hide-header-close": true,
          },
          on: { ok: _vm.modalOk, hide: _vm.modalOk, cancel: _vm.modalOk },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function () {
                return [
                  _c("div", { staticClass: "terms-of-use-header" }, [
                    _c("h5", { staticClass: "terms-of-use-header__title" }, [
                      _vm._v(" " + _vm._s(_vm.$t("termosdeuso")) + " "),
                    ]),
                    _c("p", { staticClass: "terms-of-use-header__subtitle" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("termosdeusosubtitulo")) + " "
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "modal-footer",
              fn: function ({ ok }) {
                return [
                  _c(
                    "div",
                    { staticClass: "terms-of-use-footer" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "terms-of-use-footer__checkbox",
                          attrs: {
                            id: "checkbox-1",
                            name: "checkbox-1",
                            value: true,
                            "unchecked-value": false,
                          },
                          model: {
                            value: _vm.termsOfUse,
                            callback: function ($$v) {
                              _vm.termsOfUse = $$v
                            },
                            expression: "termsOfUse",
                          },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("aceitotermosdeuso")) + " "
                          ),
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "terms-of-use-footer__button",
                          attrs: { variant: "none", disabled: !_vm.termsOfUse },
                          on: {
                            click: function ($event) {
                              return ok()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("avancar")) + " ")]
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "div",
            { staticClass: "terms-of-use-body" },
            [
              _c("terms-of-use-pdf-viewer", {
                attrs: { file: _vm.termodeusoFile },
              }),
            ],
            1
          ),
        ]
      ),
      _c("hamburger", {
        attrs: {
          id: "hamburger-container",
          "is-active": _vm.sidebar.opened,
          "aria-label": _vm.$t("togglesidebar"),
        },
        on: { toggleClick: _vm.toggleSideBar },
      }),
      _vm.device !== "mobile"
        ? _c("breadcrumb", { attrs: { id: "breadcrumb-container" } })
        : _vm._e(),
      _c("div", { staticClass: "app-header__spacer" }),
      _c("company-switcher"),
      _vm.user && _vm.device !== "mobile"
        ? [
            _c("span", {
              staticClass: "header-user-menu-divider",
              attrs: { "aria-hidden": "true" },
            }),
            _c("header-user-menu"),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }